import React from "react";
import {Button} from "reactstrap";


export default class SFXButtonComponent extends React.Component {

  constructor(props) {
    super(props);
    this.disableClickEvent = false;

    this.onClickOverride = this.onClickOverride.bind(this);
  }

  onClickOverride(e) {
    if (this.disableClickEvent) return;
    this.props.onClick(e);

    this.disableClickEvent = true;

    let self = this;
    setTimeout(() => {
      self.disableClickEvent = false;
    }, 1500);
  }

  render() {

    let classNameOriginal = this.props.className || "";

    let classNameOverride = '';
    let primary = this.props.color;

    if (this.props.color === "green") {
      primary = "success"
    }
    else if (classNameOriginal.indexOf("btn btn-success") >= 0 || this.props.color === "success" || this.props.color === "primary") {
      classNameOverride = classNameOriginal.replace("btn btn-success", "");
      primary = 'sfx-primary';
    }
    else if (classNameOriginal.indexOf("btn btn-secondary") >= 0 || this.props.color === "secondary") {
      classNameOverride = classNameOriginal.replace("btn btn-secondary", "");
      primary = 'sfx-secondary';
    }
    else if (classNameOriginal.indexOf("btn btn-danger") >= 0 || this.props.color === "danger") {
      classNameOverride = classNameOriginal.replace("btn btn-danger", "");
      primary = 'sfx-danger';
    }
    else {
      classNameOverride = classNameOriginal;
    }

    let onClickEvent = undefined;
    if (this.props.onClick !== undefined) {
      onClickEvent = this.onClickOverride;
    }


    return <Button
      {...this.props}
      onClick={onClickEvent}
      className={classNameOverride}
      color={primary}
      type={this.props.type}
    >
      {this.props.children}
    </Button>
  }
}



// WEBPACK FOOTER //
// ./src/components/SFXButtonComponent.js